import { motion } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { StarField } from "@/components/landing/StarField";
import { CTAButton, ChannelLink, ChatCTAButton } from "@/components/landing/CTAButton";

export const FinalCta = () => {
  return (
    <section className="relative overflow-hidden py-28 sm:py-36" data-testid="final-cta-section">
      <StarField count={30} />
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[400px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#5B3A78]/30 blur-[130px]" />

      <div className="relative z-10 mx-auto max-w-3xl px-4 text-center sm:px-8">
        <Reveal>
          <h2 className="font-serif text-4xl font-bold leading-tight text-[#EDE6D3] sm:text-5xl lg:text-6xl">
            Ваш первый разбор <br />
            <span className="text-gold-gradient">уже ждёт вас</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-[#EDE6D3]/65 sm:text-lg">
            Напишите Бабушке Варваре прямо здесь, на сайте — анонимно, без
            регистрации и займёт всего пару минут.
          </p>
          <motion.div
            className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row"
          >
            <ChatCTAButton testId="final-cta-chat">
              Начать разбор здесь
            </ChatCTAButton>
            <CTAButton
              goal="cta_telegram_bot"
              platform="telegram"
              primary={false}
              size="sm"
              showArrow={false}
              testId="final-cta-bot-telegram"
            >
              В Telegram
            </CTAButton>
            <CTAButton
              goal="cta_max_bot"
              platform="max"
              primary={false}
              size="sm"
              showArrow={false}
              testId="final-cta-bot"
            >
              В MAX
            </CTAButton>
          </motion.div>

          <div className="mt-4 flex flex-wrap items-center justify-center gap-4 text-sm text-[#EDE6D3]/55">
            <span>Или подпишитесь на канал:</span>
            <ChannelLink platform="max" goal="cta_max_channel" testId="final-cta-channel">
              Бабушка Варвара в MAX
            </ChannelLink>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
